const validationActions = {
  // VALIDATION_STATE_INIT: 'VALIDATION_STATE_INIT',
  VALIDATION_STATE_SET: 'VALIDATION_STATE_SET',
  VALIDATION_STATE_FORM_PROP_SET: 'VALIDATION_STATE_FORM_PROP_SET',
  VALIDATION_STATE_FORM_PROP_DELETE: 'VALIDATION_STATE_FORM_PROP_DELETE',
  VALIDATION_STATE_PROP_SET: 'VALIDATION_STATE_PROP_SET'
};

export default validationActions;